module.exports = __webpack_public_path__ + "static/media/univas.fc982a0a.png";